<button *ngIf="button" class="btn {{object.button_class}} btn-loading" [disabled]="disabled || object.loading"
	(click)="clicked.emit(true)" [ngClass]="logo && object.loading?'button-flex':''">
	<ng-container *ngIf="!object.loading">
		<i class="fa {{object.icon}}"></i>
	</ng-container>
	<ng-container *ngIf="object.loading">
		<ng-container *ngIf="!logo">
			<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
			<span role="status"></span>
		</ng-container>
		<app-loading-animation [color]="colorLoading" [height]="heightLogo" *ngIf="logo"></app-loading-animation>
	</ng-container>{{changingMessage?changingMessage.new:object.message}}
</button>
<div *ngIf="!button">
	<span *ngIf="!object.loading" class="clickeable {{object.button_class}}" (click)="clicked.emit(true)">
		<i class="fa {{object.icon}}"></i>
	</span>
	<span *ngIf="object.loading">
		<app-loading-animation></app-loading-animation>
	</span>
</div>